// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2nhxx","detailsBorder":"styles_detailsBorder__2q0jq"};